import Constants from '@/utils/Constants'
import downloadUtil from '@/utils/downloadUtil'
import axios from 'axios'

class DownloadService {
  async downloadManual (slug) {
    let config = {
      baseURL: Constants['apiEndPoint'],
      headers: {
        Authorization: 'bearer ' + Constants.getToken()
      },
      responseType: 'blob'
    }

    return axios.get('/manual/download/' + slug, config)
  }

  async download (fileName, extension, response) {
    let config = {
      baseURL: Constants['apiEndPoint'],
      headers: {
        Authorization: 'bearer ' + Constants.getToken()
      },
      responseType: 'blob'
    }
    const result = await response(config)

    if (result.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      return result.data.data
    } else {
      downloadUtil(result, fileName, extension)
    }
  }

  async downloadAnalyzeDetail (slug) {
    let config = {
      baseURL: Constants['apiEndPoint'],
      headers: {
        Authorization: 'bearer ' + Constants.getToken()
      },
      responseType: 'blob'
    }

    return axios.get('/analyze_detail/download/' + slug, config)
  }

  async downloadAnalyzeMaster (slug) {
    let config = {
      baseURL: Constants['apiEndPoint'],
      headers: {
        Authorization: 'bearer ' + Constants.getToken()
      },
      responseType: 'blob'
    }

    return axios.get('/analyze_master/download/' + slug, config)
  }

  async downloadAnalyzeResult (slug) {
    let config = {
      baseURL: Constants['apiEndPoint'],
      headers: {
        Authorization: 'bearer ' + Constants.getToken()
      },
      responseType: 'blob'
    }

    return axios.get('/result/download/' + slug, config)
  }
}

export default new DownloadService()
